var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZigzag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 758,
    viewBox: "0 0 1920 758",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_9",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -162,
    width: 1921,
    height: 1144
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 -161.841H1919.5V881.293C1919.5 936.521 1874.73 981.293 1819.5 981.293H99.5C44.2715 981.293 -0.5 936.521 -0.5 881.293V-161.841Z",
    fill: "#29A7DD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1695.89 312.273L1986.02 168.918C2035.91 144.27 2096.32 165.083 2120.44 215.228L2154.76 286.584C2178.94 336.865 2157.3 397.212 2106.67 420.665L1585.13 662.268C1532.55 686.626 1470.34 661.334 1449.67 607.198L1431.73 560.186C1410.48 504.53 1345.58 479.68 1292.6 506.908L974.913 670.157C929.009 693.746 872.807 671.947 854.814 623.575C836.226 573.603 777.162 552.35 730.995 579.021L454.887 738.536C404.649 767.56 340.337 747.878 314.947 695.71L263.385 589.768C237.153 535.871 169.724 517.001 119.328 549.454L-20.2027 639.306C-72.806 673.18 -143.246 650.974 -166.913 593.057L-179.046 563.366C-197.858 517.331 -179.984 464.469 -137.096 439.296L238.359 218.927C290.835 188.127 358.423 210.937 381.504 267.236L428.1 380.892C450.731 436.091 516.349 459.323 568.671 430.661L846.898 278.244C896.599 251.018 958.81 275.664 976.38 329.54C994.014 383.613 1056.58 408.196 1106.3 380.593L1424.85 203.772C1477.25 174.685 1543.2 200.184 1562.4 256.957C1581.01 311.971 1643.82 337.999 1695.89 312.273Z",
    fill: "#ADADAD",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.66 144.233L1929.79 0.878387C1979.67 -23.7704 2040.09 -2.95723 2064.2 47.1875L2098.52 118.544C2122.71 168.825 2101.07 229.172 2050.44 252.625L1528.9 494.228C1476.32 518.586 1414.11 493.294 1393.44 439.158L1375.49 392.146C1354.24 336.489 1289.35 311.64 1236.36 338.868L918.678 502.117C872.774 525.706 816.572 503.907 798.58 455.535C779.992 405.563 720.928 384.31 674.761 410.981L398.653 570.496C348.415 599.52 284.103 579.838 258.712 527.67L207.151 421.728C180.919 367.831 113.49 348.961 63.0937 381.414L-76.4371 471.266C-129.04 505.14 -199.48 482.934 -223.147 425.017L-235.28 395.326C-254.092 349.291 -236.218 296.429 -193.33 271.256L182.125 50.8872C234.6 20.0874 302.189 42.8972 325.27 99.196L371.866 212.852C394.496 268.051 460.114 291.283 512.436 262.621L790.664 110.204C840.365 82.9777 902.575 107.623 920.146 161.5C937.779 215.573 1000.34 240.156 1050.07 212.553L1368.62 35.732C1421.02 6.64506 1486.97 32.1438 1506.17 88.9165C1524.78 143.931 1587.59 169.959 1639.66 144.233Z",
    fill: "#F8F8F8",
    fillOpacity: 0.57
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 758,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzag);
export default __webpack_public_path__ + "static/media/zigzag.2dde9c6fa95abc0104430fb59bb17528.svg";
export { ForwardRef as ReactComponent };